import React from 'react';

import Button, { BUTTON_COLORS, BUTTON_VARIANTS } from 'js/src/components/common/ui/Button';

type Props = {
    onClick: () => void;
};
const ResumeRecordingButton: React.FC<Props> = ({ onClick }) => {
    return (
        <Button
            text="Resume"
            color={BUTTON_COLORS.TERTIARY}
            variant={BUTTON_VARIANTS.OUTLINE}
            iconLeft="play_arrow"
            onClick={onClick}
            className="material-symbols-f1"
        />
    );
};
export default React.memo(ResumeRecordingButton);
